import { useState } from 'react';
import Navbar from './navbar';
import Sidebar from './sidebar';
import Footer from './footer';

function Layout({ children }: { children: React.ReactNode }) {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [isMobileOpen, setIsMobileOpen] = useState(false);

    return (
        <div className="min-h-screen flex flex-col">
            <Navbar
                isCollapsed={isCollapsed}
                isMobileOpen={isMobileOpen}
                setIsMobileOpen={setIsMobileOpen}
            />
            <Sidebar
                isCollapsed={isCollapsed}
                setIsCollapsed={setIsCollapsed}
                isMobileOpen={isMobileOpen}
                setIsMobileOpen={setIsMobileOpen}
            />
            <main className={`flex-1 pt-16 transition-all duration-300  ${isCollapsed ? 'lg:ml-20' : 'lg:ml-72'}`}>
                <div className="mx-auto">
                    {children}
                </div>
            </main>
            <div className={`  transition-all duration-300  ${isCollapsed ? 'lg:ml-20' : 'lg:ml-72'}`}>
                <Footer />
            </div>
        </div>
    );
}

export default Layout;